import _ from 'lodash';

export function getIconDefinition(certType = 'cert', activeItem?) {
  const tagType = certType.replace(/ies$/, 'y').replace(/s$/, '');
  const isActive = !!activeItem && RegExp(tagType, 'i').test(activeItem);

  switch (tagType) {
    case 'cert':
      return 'shield';
    case 'role':
      return 'address card outline';
    case 'position':
      return 'id badge outline';
    case 'employer':
      return 'building outline';
    case 'taggroup':
      return isActive ? 'pallet' : 'boxes';
    default:
      return 'question';
  }
}

export function getTitle(certType = 'cert') {
  switch (certType) {
    case 'cert':
      return 'Certifications';
    case 'role':
    default:
      return _.capitalize(certType).replace(/$/, 's').replace(/ys$/, 'ies');
  }
}

export default {
  getIconDefinition,
  getTitle,
};
